<template>
  <div>
        <router-view/>
  </div>
</template>
<script>

export default {
  name: "layout",
  components: {

  }
};
</script>
<style lang="scss" scoped>


</style>